import React, { useState } from "react";
import { useProjects } from "../pages/ProjectContext";
import AppCard from "../components/AppCard";
import Reveal from "../components/Reveal";

const filters = ["All", "AI", "Health", "Client work"];

// "Client work" cuts across domains, so it filters on the client field
// rather than on category.
const matches = (project, filter) => {
  if (filter === "All") return true;
  if (filter === "Client work")
    return Boolean(project.client || project.clientConfidential);
  return project.category === filter;
};

const Portfolio = () => {
  const [selectedFilter, setSelectedFilter] = useState("All");
  const { projects } = useProjects();

  const displayedProjects = projects.filter((p) => matches(p, selectedFilter));

  return (
    <div className="bg-ink pt-28 lg:pt-32">
      {/* Hero */}
      <section className="relative overflow-hidden px-6 pt-16 pb-20 text-center">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_60%_60%_at_50%_40%,rgba(91,62,255,0.16)_0%,transparent_70%)]" />
        <div className="pointer-events-none absolute inset-0 hero-grid" />

        <div className="relative z-10 max-w-4xl mx-auto">
          <p className="eyebrow mb-6 fade-up" style={{ animationDelay: "0.2s" }}>
            iOS · Android · Web · Backend
          </p>
          <h1
            className="font-display text-[clamp(56px,10vw,120px)] leading-[0.92] tracking-wide text-paper fade-up"
            style={{ animationDelay: "0.35s" }}
          >
            Work we've <span className="text-brand-cyan">shipped</span>
          </h1>
          <p
            className="mt-7 mx-auto max-w-xl text-muted text-[17px] leading-relaxed fade-up"
            style={{ animationDelay: "0.55s" }}
          >
            Not concepts or case studies. Products we've launched — our own, and
            our clients'.
          </p>
        </div>
      </section>

      {/* Filters */}
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-wrap gap-3 pb-10 border-b border-ink-line">
          {filters.map((filter) => {
            const active = selectedFilter === filter;
            const count = projects.filter((p) => matches(p, filter)).length;
            return (
              <button
                key={filter}
                onClick={() => setSelectedFilter(filter)}
                className={`rounded-full px-6 py-2.5 min-h-[44px] font-mono text-[11px] tracking-[0.18em] uppercase cursor-pointer
                  transition-all duration-200 border focus-visible:ring-2 focus-visible:ring-brand-cyan ${
                    active
                      ? "bg-brand border-brand text-white shadow-glow"
                      : "bg-ink-card border-ink-line text-muted hover:text-paper hover:border-brand/50"
                  }`}
              >
                {filter}
                <span className={active ? "text-white/60 ml-2" : "text-muted/60 ml-2"}>
                  {count}
                </span>
              </button>
            );
          })}
        </div>
      </div>

      {/* Grid */}
      <div className="max-w-7xl mx-auto px-6 mt-12 pb-28 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
        {displayedProjects.length === 0 && (
          <div className="col-span-full text-center text-muted py-14">
            No projects found in this category.
          </div>
        )}
        {displayedProjects.map((proj, i) => (
          <Reveal key={proj.id} delay={(i % 3) * 100}>
            <AppCard project={proj} />
          </Reveal>
        ))}
      </div>
    </div>
  );
};

export default Portfolio;
